import { type HeadingLevel } from "@boi/components-core";

export const TAB_LIST_VIEWS = ["desktop", "mobile", null] as const;

export const DEFAULT_DESKTOP_HEADING_LEVEL = 2 satisfies HeadingLevel;
